var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConnectionLeftArrow = function SvgConnectionLeftArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 14,
    viewBox: "0 0 162 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_29291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.333,
    y: 14,
    width: 1,
    height: 14,
    transform: "rotate(-180 161.333 14)",
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.33337,
    y: 14,
    width: 1,
    height: 13,
    transform: "rotate(-180 6.33337 14)",
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.333,
    y: 14,
    width: 156,
    height: 1,
    transform: "rotate(-180 161.333 14)",
    fill: "#A1A4B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 1.91421L2.18689 5.06066L1.47978 4.35355L5.83334 0L10.1869 4.35355L9.47978 5.06066L6.33334 1.91421L6.33334 13.2071L5.33334 13.2071L5.33334 1.91421Z",
    fill: "#A1A4B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_29291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.667,
    height: 14,
    fill: "white",
    transform: "matrix(-1 0 0 -1 161.333 14)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConnectionLeftArrow);
export { ForwardRef as ReactComponent };